"use strict";

module.exports = require("./is-implemented")()
	? Object.assign
	: require("./shim");



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/object/assign/index.js
// module id = 321
// module chunks = 0